import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { getToken, getUserType, getUserInfo } from '../utils/common';
import { HOME,BMICALCULATOR, ONBOARDING } from '../helpers/Constant';

function Splash() {
  const navigate = useNavigate();
  const isLoggedIn = getToken();
  const userType = getUserType();
  const userInfo = getUserInfo();
  useEffect(() => {
    setTimeout(() => {
      if (isLoggedIn) {
        if (userType === 'real_user' && userInfo && (userInfo.isTrialComplete === false && userInfo.trialCompleteAt === null)) {
          navigate(`/${BMICALCULATOR}`, { replace: true });
        } else{
          navigate(`/${HOME}`, { replace: true });
        }
      } else {
        navigate(`/${ONBOARDING }`, { replace: true });
      }
    }, 1000);
  }, [isLoggedIn, navigate]);

  return (
    <div className='wrapper h-100 bg_splash'>
      <div className='splash-container d-flex align-items-center justify-content-center position-fixed top-0 start-0 h-100 w-100'>
        <img src='../images/muvelogo.png' alt='muvelogo' />
      </div>
    </div>
  )
}

export default Splash